import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'SubTitle',
  props: {
  titleText: {
    default: '',
    type: String
  },
  modeClass: {
    default: '',
    type: String
  },
},
  setup(__props) {

const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["subtitle", __props.modeClass])
  }, [
    _createElementVNode("span", null, _toDisplayString(__props.titleText), 1)
  ], 2))
}
}

})